import script from "./BetslipComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./BetslipComponent.vue?vue&type=script&setup=true&lang=js"

import "./BetslipComponent.vue?vue&type=style&index=0&id=cb08dbb8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb08dbb8"]])

export default __exports__